import { Component, ViewEncapsulation } from "@angular/core";

@Component({
  selector: 'phx-floating-button-group',
  templateUrl: './phx-floating-button-group.component.html',
  styleUrls: ['./phx-floating-button-group.component.scss'],
  host: {
    class: 'phx-floating-button-group',
  },
  encapsulation: ViewEncapsulation.None,
})
export class PhxFloatingButtonGroupComponent { }
